import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft, LogIn } from 'lucide-react';
import './Login.css';

const Login = () => {
  const { signInWithGoogle, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated && !loading) {
      navigate('/home', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithGoogle();
      if (result.success) {
        console.log('Sign in initiated successfully');
      } else {
        console.error('Sign in failed:', result.error);
      }
    } catch (error) {
      console.error('Sign in error:', error);
    }
  };

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-loading">
            <div className="loading-spinner" />
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-bg-grid" aria-hidden="true" />
      <div className="login-card">
        <div className="login-logo-wrap">
          <img
            src="/ApolloLogo.png"
            alt="Apollo Medical AI"
            className="login-logo"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className="login-logo-fallback" style={{ display: 'none' }}>
            <LogIn size={28} />
          </div>
        </div>

        <h1 className="login-title">Welcome to Apollo</h1>
        <p className="login-subtitle">
          Sign in with your Google account to access advanced healthcare tools and simulations.
        </p>

        <button
          onClick={handleGoogleSignIn}
          disabled={loading}
          className="google-login-button"
        >
          {loading ? (
            <>
              <div className="loading-spinner" />
              Signing in...
            </>
          ) : (
            <>
              <svg className="google-icon-svg" viewBox="0 0 24 24" width="18" height="18">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              Continue with Google
            </>
          )}
        </button>

        <div className="login-divider">
          <span>Secure authentication via Google</span>
        </div>

        <button
          onClick={() => navigate('/')}
          className="login-back-button"
        >
          <ArrowLeft size={16} />
          Back to home
        </button>
      </div>
    </div>
  );
};

export default Login;
